import React from 'react';
import { Chip } from 'primereact/chip';
import { Tooltip } from 'primereact/tooltip';

const ProteinFeatureChips = ({ data, setActiveTabIndex }) => {

  const ActiveTabIndex = {
    "Chain": 1,
    "Domain": 1,
    "PDB": 1,
    "InterPro domain": 1,
    "Active site": 1,
    "Binding site": 1,
    "Modified residue": 1,
    "Lipidation": 1,
    "PTMs PhosphoSitePlus®": 1,
    "IntAct Binding Region": 1,
    "Intra-protein contact": 2,
    "Inter-protein contact": 3,
    "Ligand": 4,
    "Natural variant": 1,
    "ClinVar variant": 5
  };

  const featureData = {
    "Chain": data?.countByFeatureType?.chain,
    "Domain": data?.countByFeatureType?.domain,
    "PDB": data?.countByFeatureType?.pdb,
    "InterPro domain": data?.countByFeatureType?.interprot,
    "Active site": data?.countByFeatureType?.active,
    "Binding site": data?.countByFeatureType?.binding,
    "Modified residue": data?.countByFeatureType?.modified,
    "Lipidation": data?.countByFeatureType?.lipidation,
    "PTMs PhosphoSitePlus®": data?.countByFeatureType?.ptm,
    "IntAct Binding Region": data?.countByFeatureType?.bindingRegion,
    "Intra-protein contact": data?.countByFeatureType?.intraContact,
    "Inter-protein contact": data?.countByFeatureType?.interContact,
    "Ligand": data?.countByFeatureType?.ligand,
    "Natural variant": data?.countByFeatureType?.variant,
    "ClinVar variant": data?.countByFeatureType?.clinvar
  };

  return (
    <div className="p-3">
      <Tooltip target=".feature-chip-text" />
      <h2 className="h5 mb-4">Protein Features Overview</h2>
      <div className="d-flex flex-wrap gap-2">
        {Object.entries(featureData).map(([feature, count]) => {
          const content = (
            <div className="d-flex align-items-center"
                onClick={() => setActiveTabIndex(ActiveTabIndex[feature])}>
              <span
                className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                style={{ width: '24px', height: '24px', fontSize: '0.75rem' }}
              >
                {count}
              </span>
              <span
                className="ms-2 feature-chip-text"
                data-pr-tooltip="Click here to access the tab"
              >
                {feature}
              </span>
            </div>
          );

          return (
            <Chip
              key={feature}
              template={content}
              className="px-2 py-1 me-2 mb-2 bg-light rounded-pill border"
              style={{ display: 'inline-flex', alignItems: 'center' }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProteinFeatureChips;
